export const AT_APPOINTMENT = 'at-appointment';
export const UNTIL_APPOINTMENT = 'until-appointment';

const LABELS = {
	[AT_APPOINTMENT]: 'wird am vereinbarten Termin stattfinden',
	[UNTIL_APPOINTMENT]: 'soll bis zum vereinbarten Termin durchgeführt werden',
};

export function getLabel (id)
{
	return LABELS[id];
}